<div class="p-6">
  <h2 class="text-xl font-semibold text-gray-900 mb-6">Create Property</h2>
  
  <form [formGroup]="createPropertyForm" class="space-y-6">
    <!-- Name Input -->
    <div>
      <label for="propertyName" class="block text-sm font-medium text-gray-700 mb-2">
        Name
      </label>
      <input
        id="propertyName"
        type="text"
        formControlName="name"
        placeholder="Enter property name"
        class="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white text-gray-900 placeholder-gray-500 transition-colors duration-200"
      >
    </div>

    <!-- Total Area Input -->
    <div>
      <label for="propertyArea" class="block text-sm font-medium text-gray-700 mb-2">
        Total Area (ha)
      </label>
      <input
        id="propertyArea"
        type="number"
        [value]="property.area"
        readonly
        class="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm bg-gray-50 text-gray-600 cursor-not-allowed"
      >
    </div>

    <!-- Notes Textarea -->
    <div>
      <label for="propertyNotes" class="block text-sm font-medium text-gray-700 mb-2">
        Notes
      </label>
      <textarea
        id="propertyNotes"
        formControlName="notes"
        rows="6"
        placeholder="Enter any additional notes about the property"
        class="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white text-gray-900 placeholder-gray-500 transition-colors duration-200 resize-vertical"
      ></textarea>
    </div>
  </form>
</div>
<div class="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end gap-3">
  <button 
    type="button" 
    class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200"
    [mat-dialog-close]="false"
  >
    Cancel
  </button>
  <button
    type="button"
    class="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
    (click)="submit()"
    [disabled]="!createPropertyForm.valid"
  >
    Save
  </button>
</div>
